__webpack_require__.p = "//static.hsappstatic.net/payments-ui-app/static-1.25527/";